import React, { useEffect, useState, Children, Fragment, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, Plus, Minus, Info, X, Calendar, Truck, MapPin, ShoppingBag, Trash2 } from 'lucide-react';
import { Button } from './ui/Button';
import { ServiceType } from './Navigation';
interface CateringCatalogProps {
  onOrderClick: (type: ServiceType) => void;
  businessOrderTrigger?: number;
}
const catalogData = [{
  category: 'Bullar',
  items: [{
    name: 'Kanelbulle',
    image: 'https://cdn.magicpatterns.com/uploads/hwcTF2GfMBWMf1YuqZ5h5u/image_10.png',
    description: 'Vetebulle med kanelfyllning och mandelmassa.'
  }, {
    name: 'Vaniljbulle',
    image: 'https://cdn.magicpatterns.com/uploads/rEA8A9kv65fkpBp4so79L4/image_6.png',
    description: 'Vetebulle fylld med vaniljkräm, doppad i kardemummasocker.'
  }, {
    name: 'Kardemumma',
    image: 'https://cdn.magicpatterns.com/uploads/sUjNTjcZYXjnSJ4pBC7d7n/image_7.png',
    description: 'Vetebulle med smör och kardemummafyllning.'
  }, {
    name: 'Stickybun',
    image: 'https://cdn.magicpatterns.com/uploads/iqGFaHSzMboJ6yRGias7KE/image_4.png',
    description: 'Saftig karlspaderbulle toppad med kolasås, flingsalt och havresmul.'
  }, {
    name: 'Wiernerbröd - smak kan variera',
    image: 'https://cdn.magicpatterns.com/uploads/ms5qNpDtoKYKw4yDu8smSF/image_10.png',
    description: 'Flaky wienerdeg fylld med kolakräm och toppat med söt glasyr.'
  }, {
    name: 'Banoffee bulle med choklad och havresmul',
    image: 'https://cdn.magicpatterns.com/uploads/appg4NNekEnFadYTPq7JVT/image_8.png',
    description: 'Kreativ bulle inspirerad av banoffee pie – med banan, choklad och krispig havresmul.'
  }, {
    name: 'Birkes med lite mandelfyllning',
    image: 'https://cdn.magicpatterns.com/uploads/dEKG1snmX55KP9wqTu3DQC/image_7.png',
    description: 'Dansk birkes i smördeg med en lätt mandelfyllning inuti.'
  }]
}, {
  category: 'Choklad',
  items: [{
    name: 'Chokladboll med pärlsocker',
    image: 'https://cdn.magicpatterns.com/uploads/kxYvUqLMq1ZUBfKUi9acni/image_1.png',
    description: 'Fluffig chokladboll med svenskt smör, glutenfria havregryn och kaffe, rullad i mörk choklad och pärlsocker.'
  }, {
    name: 'Chokladboll med rostad kokos',
    image: 'https://cdn.magicpatterns.com/uploads/2WvQ2jpSEGf11DMX5AxgwL/image_2.png',
    description: 'Fluffig chokladboll med svenskt smör, glutenfria havregryn och kaffe, rullad i rostad kokos.'
  }, {
    name: 'Kaffe & hasselnötsbar',
    image: 'https://cdn.magicpatterns.com/uploads/3qu6qPQX1n2aEe1CorJUYX/image_1.png',
    description: 'Browniebotten med kaffetryffel, doppad i mjölkchoklad och hasselnötter.',
    sizeOptions: [{
      key: 'hel',
      label: 'Hel (80g)'
    }, {
      key: 'halv',
      label: 'Halv (40g)'
    }]
  }, {
    name: 'Kladdkaka cookiedough bar',
    image: 'https://cdn.magicpatterns.com/uploads/7EyJLhF69KvJZCW4iWizvP/image_2.png',
    description: 'Kladdkaka med salt kolasås och cookie dough.',
    sizeOptions: [{
      key: 'hel',
      label: 'Hel (80g)'
    }, {
      key: 'halv',
      label: 'Halv (40g)'
    }]
  }, {
    name: 'Hallonbar',
    image: 'https://cdn.magicpatterns.com/uploads/5wPaNtL3Ta12H5fToe57yh/image_3.png',
    description: 'Browniebotten med hallontryffel, doppad i mörk choklad.',
    sizeOptions: [{
      key: 'hel',
      label: 'Hel (80g)'
    }, {
      key: 'halv',
      label: 'Halv (40g)'
    }]
  }, {
    name: "Let's go nuts",
    image: 'https://cdn.magicpatterns.com/uploads/kvNw4SWykoJ1wcp53hBzsY/image_4.png',
    description: 'Browniebotten toppad med en nöttosca gjord på hasselnötter, jordnötter, mandel och valnötter.',
    sizeOptions: [{
      key: 'hel',
      label: 'Hel (80g)'
    }, {
      key: 'halv',
      label: 'Halv (40g)'
    }]
  }, {
    name: 'Biskvi med brynt smör',
    image: 'https://cdn.magicpatterns.com/uploads/eDvgtKwdWN3CdQHLnCh64V/image_5.png',
    description: 'Biskvi gjord på brynt smör och marängsmörkräm, doppad i mörk choklad.'
  }]
}, {
  category: 'Bakelser',
  items: [{
    name: 'Morotskaka',
    image: 'https://cdn.magicpatterns.com/uploads/pXzUCx2ewaUkHRhBSRwXBz/image_4.png',
    description: 'Saftig morotskaka med färskostfrosting.',
    sizeOptions: [{
      key: 'bit',
      label: 'Bit'
    }, {
      key: 'hel',
      label: 'Hel (10 bitar)'
    }]
  }, {
    name: 'Cheesecake - smak kan variera veckovis',
    image: 'https://cdn.magicpatterns.com/uploads/x9hQsb7YhedcDdS7pVEh5p/image_1.png',
    description: 'Krämig cheesecake på digestivebotten. Smaken varierar veckovis. En bit eller hel tårta (10 bitar).',
    sizeOptions: [{
      key: 'bit',
      label: 'Bit'
    }, {
      key: 'hel',
      label: 'Hel (10 bitar)'
    }]
  }, {
    name: 'Chokladbakelse - fyllning kan variera',
    image: 'https://cdn.magicpatterns.com/uploads/nMnXnEyAyUwCAmWF17BxD2/image_3.png',
    description: 'Lyxig chokladbakelse – fyllningen varierar efter säsong.'
  }, {
    name: 'Sockerdonuts',
    image: 'https://cdn.magicpatterns.com/uploads/gr18rB2X5A1DoHmc9rxLcD/image_2.png',
    description: 'Donutsdeg gjord på växtbaserade produkter, doppad i socker.'
  }, {
    name: 'Chokladmunk med hallon',
    image: 'https://cdn.magicpatterns.com/uploads/nHkuCnKZRft85EMTNinMJu/image_3.png',
    description: 'Chokladdoppad munk fylld med hallonkräm.'
  }]
}, {
  category: 'Tårtor',
  items: [{
    name: 'Jordgubbstårta',
    image: 'https://cdn.magicpatterns.com/uploads/bL3rJTjjrBMbmELoS77Zky/IMG_0215.png',
    description: 'Sockerkaksbotten, jordgubb- och limekompott, vaniljkräm, grädde och färska jordgubbar. 4 personer 250 kr / 10 personer 550 kr.',
    sizeOptions: [{
      key: '4p',
      label: '4 pers (250 kr)'
    }, {
      key: '10p',
      label: '10 pers (550 kr)'
    }]
  }, {
    name: 'Prinsesstårta',
    image: 'https://cdn.magicpatterns.com/uploads/vNpS3V9AW2ppAeFCjAviAS/IMG_0227.png',
    description: 'Sockerkaksbotten, hallonkompott, vaniljkräm och grädde, täckt med rosa marsipan och dekorerad med marsipanblommor. 4 personer 200 kr / 10 personer 500 kr.',
    sizeOptions: [{
      key: '4p',
      label: '4 pers (200 kr)'
    }, {
      key: '10p',
      label: '10 pers (500 kr)'
    }]
  }, {
    name: 'Chokladtårta',
    image: 'https://cdn.magicpatterns.com/uploads/nNPQraaRXoQvZR1EkXTcW1/IMG_0462.png',
    description: 'Chokladbottnar, chokladmousse och passionscurd, uppstruken i chokladsmörkräm. 10 personer 650 kr.',
    sizeOptions: [{
      key: '10p',
      label: '10 pers (650 kr)'
    }]
  }, {
    name: 'Morotstårta',
    image: 'https://cdn.magicpatterns.com/uploads/ngNuvWorwjZPdbXmEDpLp4/IMG_0463.png',
    description: 'Morotsbotten med färskostfrosting. 10 personer 550 kr.',
    sizeOptions: [{
      key: '10p',
      label: '10 pers (550 kr)'
    }]
  }]
}, {
  category: 'Frukost',
  items: [{
    name: 'Overnight oats med chia, mango & rostad kokos',
    image: 'https://cdn.magicpatterns.com/uploads/btDCBM4zYfDosX7Cjoz5sJ/image_5.png',
    description: 'Krämig overnight oats med chia, toppad med färsk mango och rostad kokos.'
  }, {
    name: 'Yoghurt med granola',
    image: 'https://cdn.magicpatterns.com/uploads/5PaXYLwJS6HSDBeamYcTEg/image_8.png',
    description: 'Naturell yoghurt serverad med hemgjord knaprig granola.'
  }, {
    name: 'Frukostpaket 1 exempel – ost & grönt fralla, äppeljuice, overnight oats',
    image: 'https://cdn.magicpatterns.com/uploads/j5huTsc5D8GTc48z7Mi9vA/image_4.png',
    description: 'Komplett frukostpaket med ostmacka, juice och tillbehör.'
  }, {
    name: 'Frukostpaket 2 exempel – salami & brie, juice, overnight oats',
    image: 'https://cdn.magicpatterns.com/uploads/oaqcoRs7AtqqsBfzp9qQiv/image_5.png',
    description: 'Lyxigt frukostpaket med salami & brie-macka, juice och chiapudding.'
  }, {
    name: 'Frukostpaket 3 exempel – yoghurt, äppeljuice, ost& skinka macka',
    image: 'https://cdn.magicpatterns.com/uploads/uWGdM1CqdWDFTBdzCXbCKF/image_8.png',
    description: 'Varierat frukostpaket med yoghurt, äppeljuice och ost & skinka-macka.'
  }, {
    name: 'Bärsmoothie - Acai, jordgubb, blåbär\nKan variera i smak månadsvis. Görs på frukt och äppeljuice.',
    image: 'https://cdn.magicpatterns.com/uploads/2Bf39hYWMB4MJJ3DK1n8Pn/image_1.png',
    description: 'Smoothie gjord på acai, jordgubb och blåbär med äppeljuice som bas.'
  }, {
    name: 'Tropisk smoothie - Ananas, Mango, Passion\nGörs på frukt och äppleljuice som bas',
    image: 'https://cdn.magicpatterns.com/uploads/g59kb85GwBq2saoXYoMuYp/image_2.png',
    description: 'Fruktig smoothie med ananas, mango och passion. Görs på äppeljuice som bas.'
  }, {
    name: 'Apelsinjuice',
    image: 'https://cdn.magicpatterns.com/uploads/gfrmVeQToRRqoSF2kVxzTi/apelsin.png',
    description: 'Nypressad apelsinjuice.'
  }, {
    name: 'Äppeljuice',
    image: 'https://cdn.magicpatterns.com/uploads/qWL7Ry5cDHi6NTYhGVb8kd/image_3.png',
    description: 'Nypressad äppeljuice.'
  }, {
    name: 'Salami & brie macka',
    image: 'https://cdn.magicpatterns.com/uploads/wRdWtzxiF5fpCS6BK2bJMJ/image_6.png',
    description: 'Macka med salami och krämig brie på nybakat bröd.'
  }, {
    name: 'Ost & grönt macka',
    image: 'https://cdn.magicpatterns.com/uploads/72QLJXzbkMtkoFF5qCP7v4/Ostfralla.png',
    description: 'Fralla med ost, gurka, tomat och grönsaker.'
  }, {
    name: 'Ost & skinka macka',
    image: 'https://cdn.magicpatterns.com/uploads/nBX36XN7caBhcxi56hf1bH/ostskinka.png',
    description: 'Fralla med skinka, ost, grönsaker och krasse.'
  }]
}, {
  category: 'Frallor & Bröd',
  items: [{
    name: 'Surdegs vete fralla',
    image: 'https://cdn.magicpatterns.com/uploads/5p2XyheDPdYKpSonQJEdex/image_6.png',
    description: 'Surdegsfralla gjord på vetesurdeg.'
  }, {
    name: 'Surdegs vete fralla med herrgårdsost',
    image: 'https://cdn.magicpatterns.com/uploads/vZNCZqnv4HBxqt7agYGMai/image_5.png',
    description: 'Surdegsvetefralla gratinerad med herrgårdsost.'
  }, {
    name: 'Surdegs levain',
    image: 'https://cdn.magicpatterns.com/uploads/69haLdNUMuUxQKdTCHdGCm/image_6.png',
    description: 'Rustikt surdegsbröd bakat på lång jäsning för djup smak.'
  }]
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function CateringCatalog({
  onOrderClick,
  businessOrderTrigger
}: CateringCatalogProps) {
  const [quantities, setQuantities] = useState<Record<string, number>>({});
  const [selectedSizes, setSelectedSizes] = useState<Record<string, string>>({});
  const [initialCount, setInitialCount] = useState<number>(() => {
    if (typeof window === 'undefined') return 3;
    const w = window.innerWidth;
    if (w >= 1024) return 6;
    if (w >= 768) return 5;
    if (w >= 640) return 4;
    return 3;
  });
  useEffect(() => {
    const updateCount = () => {
      const w = window.innerWidth;
      if (w >= 1024) setInitialCount(6);else if (w >= 768) setInitialCount(5);else if (w >= 640) setInitialCount(4);else setInitialCount(3);
    };
    window.addEventListener('resize', updateCount);
    return () => window.removeEventListener('resize', updateCount);
  }, []);
  const [selectedProduct, setSelectedProduct] = useState<{
    name: string;
    image: string;
    description: string;
    sizeOptions?: {
      key: string;
      label: string;
    }[];
  } | null>(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [orderDate, setOrderDate] = useState('');
  const [orderTime, setOrderTime] = useState('');
  const [deliveryType, setDeliveryType] = useState<'avhämtning' | 'upphämtning'>('avhämtning');
  const [customerType, setCustomerType] = useState<'företag' | 'privatperson'>('företag');
  const [orderFrequency, setOrderFrequency] = useState<'engång' | 'återkommande'>('engång');
  const [deliveryStreet, setDeliveryStreet] = useState('');
  const [deliveryPostalCode, setDeliveryPostalCode] = useState('');
  const [deliveryCity, setDeliveryCity] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [orderTimeTo, setOrderTimeTo] = useState('');
  const [exactTime, setExactTime] = useState(false);
  const [recurringType, setRecurringType] = useState<'veckovis' | 'månadsvis' | 'annat'>('veckovis');
  const [selectedWeekdays, setSelectedWeekdays] = useState<string[]>([]);
  const [selectedMonthDates, setSelectedMonthDates] = useState<number[]>([]);
  const [recurringNote, setRecurringNote] = useState('');
  const [orgNumber, setOrgNumber] = useState('');
  const [invoiceEmail, setInvoiceEmail] = useState('');
  const [invoiceReference, setInvoiceReference] = useState('');
  const [önskemål, setÖnskemål] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showBusinessBanner, setShowBusinessBanner] = useState(false);
  const [expandedCategories, setExpandedCategories] = useState<Record<string, boolean>>({});
  const [pkgSandwich, setPkgSandwich] = useState<string[]>([]);
  const [pkgSmoothie, setPkgSmoothie] = useState<string[]>([]);
  const [pkgJuice, setPkgJuice] = useState<string[]>([]);
  const [pkgExtra, setPkgExtra] = useState<string[]>([]);
  const [pkgBun, setPkgBun] = useState<string[]>([]);
  const [pkgQuantity, setPkgQuantity] = useState<number>(1);
  const [showPkgBuilder, setShowPkgBuilder] = useState(false);
  const [pkgBuilderRendered, setPkgBuilderRendered] = useState(false);
  const togglePkgOption = (setter: React.Dispatch<React.SetStateAction<string[]>>, value: string) => {
    setter(prev => prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]);
  };
  const handleAddPackageToCart = () => {
    if (pkgSandwich.length === 0) return;
    const parts = [...pkgSandwich, ...pkgSmoothie, ...pkgJuice, ...pkgExtra, ...pkgBun];
    const compositeKey = `Frukostpaket: ${parts.join(' + ')}`;
    handleQuantityChange(compositeKey, pkgQuantity);
    setPkgSandwich([]);
    setPkgSmoothie([]);
    setPkgJuice([]);
    setPkgExtra([]);
    setPkgBun([]);
    setPkgQuantity(1);
    setShowPkgBuilder(false);
  };
  useEffect(() => {
    if (businessOrderTrigger && businessOrderTrigger > 0) {
      setCustomerType('företag');
      setShowBusinessBanner(true);
      // Auto-dismiss after 8 seconds
      const timer = setTimeout(() => setShowBusinessBanner(false), 8000);
      return () => clearTimeout(timer);
    }
  }, [businessOrderTrigger]);
  const toggleWeekday = (day: string) => {
    setSelectedWeekdays(prev => prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]);
  };
  const toggleMonthDate = (date: number) => {
    setSelectedMonthDates(prev => prev.includes(date) ? prev.filter(d => d !== date) : [...prev, date]);
  };
  const handleQuantityChange = (productKey: string, delta: number) => {
    setQuantities(prev => {
      const current = prev[productKey] || 0;
      const next = Math.max(0, current + delta);
      if (next === 0) {
        const newQuantities = {
          ...prev
        };
        delete newQuantities[productKey];
        return newQuantities;
      }
      return {
        ...prev,
        [productKey]: next
      };
    });
  };
  const totalItems = Object.values(quantities).reduce((sum, q) => sum + q, 0);
  // Helper to get product details for the cart
  const getSelectedItemsDetails = () => {
    const items: {
      name: string;
      image: string;
      quantity: number;
      category: string;
      compositeKey: string;
    }[] = [];
    catalogData.forEach(section => {
      section.items.forEach(item => {
        if ((item as any).sizeOptions) {
          ;
          (item as any).sizeOptions.forEach((option: any) => {
            const compositeKey = `${item.name}::${option.key}`;
            if (quantities[compositeKey]) {
              items.push({
                ...item,
                name: `${item.name} (${option.label})`,
                quantity: quantities[compositeKey],
                category: section.category,
                compositeKey: compositeKey
              });
            }
          });
        } else {
          if (quantities[item.name]) {
            items.push({
              ...item,
              quantity: quantities[item.name],
              category: section.category,
              compositeKey: item.name
            });
          }
        }
      });
    });
    Object.entries(quantities).forEach(([key, quantity]) => {
      if (key.startsWith('Frukostpaket:')) {
        items.push({
          name: key,
          image: 'https://cdn.magicpatterns.com/uploads/j5huTsc5D8GTc48z7Mi9vA/image_4.png',
          quantity: quantity,
          category: 'Frukost',
          compositeKey: key
        } as any);
      }
    });
    return items;
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  const isValidPhone = (phone: string) => {
    const digits = phone.replace(/[\s\-\(\)]/g, '');
    return /^(\+?46|0)\d{7,9}$/.test(digits);
  };
  const isValidPostalCode = (code: string) => /^\d{3}\s?\d{2}$/.test(code.trim());
  const isValidOrgNumber = (org: string) => /^\d{6}[\-\s]?\d{4}$/.test(org.trim());
  // Normalize phone to consistent Swedish format for Excel
  const formatPhoneForExcel = (phone: string): string => {
    const stripped = phone.replace(/[\s\-\(\)]/g, '');
    // +46 or 46 prefix → international format
    const match46 = stripped.match(/^\+?46(\d{7,9})$/);
    if (match46) {
      const num = match46[1];
      // Format as +46 XX XXX XX XX (mobile 9 digits) or +46 X XXX XX XX (landline 7-8 digits)
      if (num.length === 9) {
        return `+46 ${num.slice(0, 2)} ${num.slice(2, 5)} ${num.slice(5, 7)} ${num.slice(7)}`;
      }
      if (num.length === 8) {
        return `+46 ${num.slice(0, 1)} ${num.slice(1, 4)} ${num.slice(4, 6)} ${num.slice(6)}`;
      }
      return `+46 ${num}`;
    }
    // 0-prefix → domestic format
    const match0 = stripped.match(/^0(\d{7,9})$/);
    if (match0) {
      const num = match0[1];
      // Mobile (starts with 7): 070-123 45 67
      if (num.length === 9 && num.startsWith('7')) {
        return `0${num.slice(0, 2)}-${num.slice(2, 5)} ${num.slice(5, 7)} ${num.slice(7)}`;
      }
      // Landline 08: 08-123 456 78
      if (num.length === 8 && num.startsWith('8')) {
        return `0${num.slice(0, 1)}-${num.slice(1, 4)} ${num.slice(4, 6)} ${num.slice(6)}`;
      }
      // Generic: 0XX-XXX XX XX
      if (num.length >= 8) {
        return `0${num.slice(0, 2)}-${num.slice(2, 5)} ${num.slice(5, 7)} ${num.slice(7)}`;
      }
      return `0${num}`;
    }
    return phone.trim();
  };
  const validateForm = (): boolean => {
    const errors: Record<string, string> = {};
    // Common validations
    if (!contactPerson.trim()) errors.contactPerson = 'Namn krävs';
    if (!customerEmail.trim()) {
      errors.customerEmail = 'E-post krävs';
    } else if (!isValidEmail(customerEmail)) {
      errors.customerEmail = 'Ogiltig e-postadress';
    }
    if (!customerPhone.trim()) {
      errors.customerPhone = 'Telefon krävs';
    } else if (!isValidPhone(customerPhone)) {
      errors.customerPhone = 'Ogiltigt telefonnummer (t.ex. 070-123 45 67)';
    }
    if (!orderDate) errors.orderDate = 'Datum krävs';
    if (!orderTime) errors.orderTime = 'Tid krävs';
    if (totalItems === 0) errors.products = 'Välj minst en produkt';
    // Företag-specific
    if (customerType === 'företag') {
      if (!companyName.trim()) errors.companyName = 'Företagsnamn krävs';
      if (!orgNumber.trim()) {
        errors.orgNumber = 'Organisationsnummer krävs';
      } else if (!isValidOrgNumber(orgNumber)) {
        errors.orgNumber = 'Ogiltigt format (XXXXXX-XXXX)';
      }
      if (!invoiceEmail.trim()) {
        errors.invoiceEmail = 'Fakturamejl krävs';
      } else if (!isValidEmail(invoiceEmail)) {
        errors.invoiceEmail = 'Ogiltig e-postadress';
      }
      if (!invoiceReference.trim()) errors.invoiceReference = 'Referens krävs';
      // Delivery address validation
      if (deliveryType === 'upphämtning') {
        if (!deliveryStreet.trim()) errors.deliveryStreet = 'Gatuadress krävs';
        if (!deliveryPostalCode.trim()) {
          errors.deliveryPostalCode = 'Postnummer krävs';
        } else if (!isValidPostalCode(deliveryPostalCode)) {
          errors.deliveryPostalCode = 'Ogiltigt postnummer (t.ex. 123 45)';
        }
        if (!deliveryCity.trim()) errors.deliveryCity = 'Ort krävs';
      }
    }
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleContinue = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);
    setSubmitError('');
    // Build product summary: "Kanelbulle x3, Morotskaka x2"
    const productSummary = getSelectedItemsDetails().map(item => `${item.name} x${item.quantity}`).join(', ');
    // Build recurring schedule description
    let recurringDescription = '';
    if (orderFrequency === 'återkommande') {
      if (recurringType === 'veckovis') {
        recurringDescription = `Veckovis: ${selectedWeekdays.join(', ') || '–'}`;
      } else if (recurringType === 'månadsvis') {
        recurringDescription = `Månadsvis: datum ${selectedMonthDates.sort((a, b) => a - b).join(', ') || '–'}`;
      } else {
        recurringDescription = `Annat: ${recurringNote || '–'}`;
      }
    }
    const fullAddress = deliveryType === 'upphämtning' ? `${deliveryStreet}, ${deliveryPostalCode} ${deliveryCity}` : '';
    // Generate unique order/customer number: TNB-F-YYYYMMDD-XXXX or TNB-P-...
    const now = new Date();
    const dateStr = now.toISOString().slice(0, 10).replace(/-/g, '');
    const randomId = Math.random().toString(36).substring(2, 6).toUpperCase();
    const orderPrefix = customerType === 'företag' ? 'F' : 'P';
    const kundnummer = `TNB-${orderPrefix}-${dateStr}-${randomId}`;
    const tidsstämpel = now.toLocaleString('sv-SE');
    // Separate payloads for företag vs privatperson
    // Prio columns first: kundnummer, contact, products, date/time — then details
    const företagPayload = {
      data: [{
        Kundnummer: kundnummer,
        Tidsstämpel: tidsstämpel,
        // === PRIO: Kontakt & Beställning ===
        Kontaktperson: contactPerson,
        Epost: customerEmail,
        Telefon: formatPhoneForExcel(customerPhone),
        Produkter: productSummary,
        Antal_produkter: totalItems.toString(),
        Datum: orderDate,
        Tid_från: orderTime,
        Tid_till: orderTimeTo || '–',
        Exakt_tid: exactTime ? 'Ja' : 'Nej',
        // === Företagsuppgifter ===
        Företagsnamn: companyName,
        Organisationsnummer: orgNumber,
        Fakturamejl: invoiceEmail,
        Referens: invoiceReference,
        Önskemål: önskemål || '–',
        // === Leverans ===
        Leveranssätt: deliveryType === 'upphämtning' ? 'Utkörning' : 'Avhämtning',
        Gatuadress: deliveryType === 'upphämtning' ? deliveryStreet : '–',
        Postnummer: deliveryType === 'upphämtning' ? deliveryPostalCode : '–',
        Ort: deliveryType === 'upphämtning' ? deliveryCity : '–',
        Full_adress: fullAddress || '–',
        Google_Maps: fullAddress ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}` : '–',
        // === Återkommande ===
        Ordertyp: orderFrequency,
        Återkommande_schema: recurringDescription || '–',
        Status: 'Ny'
      }]
    };
    const privatPayload = {
      data: [{
        Kundnummer: kundnummer,
        Tidsstämpel: tidsstämpel,
        // === PRIO: Kontakt & Beställning ===
        Namn: contactPerson,
        Epost: customerEmail,
        Telefon: formatPhoneForExcel(customerPhone),
        Produkter: productSummary,
        Antal_produkter: totalItems.toString(),
        Datum: orderDate,
        Avhämtningstid: orderTime,
        Tid_till: orderTimeTo || '–',
        Exakt_tid: exactTime ? 'Ja' : 'Nej',
        // === Återkommande ===
        Ordertyp: orderFrequency,
        Återkommande_schema: recurringDescription || '–',
        // === Övrigt ===
        Status: 'Ny'
      }]
    };
    const payload = customerType === 'företag' ? företagPayload : privatPayload;
    // Build clear, scannable email for order@topnotchbakery.se
    const typeLabel = customerType === 'företag' ? '🏢 FÖRETAG' : '👤 PRIVAT';
    const leveransLabel = customerType === 'företag' ? deliveryType === 'upphämtning' ? '🚚 Utkörning' : '📍 Avhämtning' : '📍 Avhämtning i butik';
    const tidLabel = orderTime + (orderTimeTo ? ` – ${orderTimeTo}` : '') + (exactTime ? ' (EXAKT TID)' : '');
    const emailSubject = `[${kundnummer}] ${typeLabel} – ${customerType === 'företag' ? companyName : contactPerson} – ${orderDate} kl ${orderTime}`;
    const emailLines = [`════════════════════════════════`, `   ORDERNUMMER: ${kundnummer}`, `════════════════════════════════`, '', `▸ TYP:        ${typeLabel}`, `▸ DATUM:      ${orderDate}`, `▸ TID:        ${tidLabel}`, `▸ LEVERANS:   ${leveransLabel}`, '', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   PRODUKTER`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`];
    // List each product on its own line
    getSelectedItemsDetails().forEach(item => {
      emailLines.push(`  • ${item.name}  ×${item.quantity}`);
    });
    emailLines.push(`  ─────────────────`);
    emailLines.push(`  Totalt: ${totalItems} st`);
    emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   KONTAKTUPPGIFTER`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  Namn:     ${contactPerson}`, `  E-post:   ${customerEmail}`, `  Telefon:  ${customerPhone}`);
    if (customerType === 'företag') {
      emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   FÖRETAGSUPPGIFTER`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  Företag:  ${companyName}`, `  Org.nr:   ${orgNumber}`, `  Faktura:  ${invoiceEmail}`, `  Referens: ${invoiceReference}`, `  Önskemål: ${önskemål || '–'}`);
      if (deliveryType === 'upphämtning') {
        emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   LEVERANSADRESS`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  ${deliveryStreet}`, `  ${deliveryPostalCode} ${deliveryCity}`, `  📍 Google Maps: https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`);
      }
      if (orderFrequency === 'återkommande' && recurringDescription) {
        emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   ÅTERKOMMANDE`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  ${recurringDescription}`);
      }
    }
    emailLines.push('', `════════════════════════════════`, `Svara direkt på detta mejl för att nå kunden.`, `════════════════════════════════`);
    const emailPayload = {
      access_key: 'c9228efa-9300-46fa-a21c-050430afdc38',
      subject: emailSubject,
      from_name: `Top Notch Order – ${contactPerson}`,
      replyto: customerEmail,
      message: emailLines.join('\n')
    };
    try {
      const SHEETDB_FORETAG = 'https://sheetdb.io/api/v1/qn4pqie7u6vgh';
      const SHEETDB_PRIVAT = 'https://sheetdb.io/api/v1/ed6aqsv2j743p';
      const SHEETDB_URL = customerType === 'företag' ? SHEETDB_FORETAG : SHEETDB_PRIVAT;
      // Send to SheetDB and email in parallel
      const [sheetRes] = await Promise.all([fetch(SHEETDB_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }), fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(emailPayload)
      })]);
      if (!sheetRes.ok) throw new Error('Kunde inte skicka förfrågan');
      setIsSubmitted(true);
    } catch (err) {
      setSubmitError('Något gick fel. Försök igen eller mejla order@topnotchbakery.se');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="catalog" className="w-full pt-4 pb-24 relative" data-id="element-94">
      {/* Business order banner */}
      <AnimatePresence data-id="element-95">
        {showBusinessBanner && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.4
      }} className="max-w-3xl mx-auto mb-8 px-4" data-id="element-96">
            <div className="flex items-center gap-3 p-4 bg-[#C4993D]/10 border border-[#C4993D]/30 rounded-xl" data-id="element-97">
              <span className="text-2xl" data-id="element-98">🏢</span>
              <div className="flex-1" data-id="element-99">
                <p className="text-sm font-semibold text-[#1A1A1A]" data-id="element-100">
                  Företagsbeställning
                </p>
                <p className="text-sm text-[#1A1A1A]/70" data-id="element-101">
                  Välj produkter nedan och klicka "Granska förfrågan" när du är
                  klar. Företag är förvalt som kundtyp.
                </p>
              </div>
              <button onClick={() => setShowBusinessBanner(false)} className="p-1.5 text-[#1A1A1A]/40 hover:text-[#1A1A1A] rounded-full hover:bg-white/50 transition-colors" data-id="element-102">
                <X className="w-4 h-4" data-id="element-103" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Order contact email */}
      <div className="max-w-2xl mx-auto mb-10 px-4" data-id="element-104">
        <div className="flex items-center gap-3 p-4 bg-white rounded-xl border border-[#7C8062]/15 shadow-sm" data-id="element-105">
          <span className="text-xl" data-id="element-106">📧</span>
          <div className="text-sm text-[#1A1A1A]/80" data-id="element-107">
            <span data-id="element-108">Frågor om beställningar? Kontakta oss på </span>
            <a href="mailto:order@topnotchbakery.se" className="text-[#7C8062] font-semibold underline underline-offset-2 hover:text-[#6A6D53] transition-colors" data-id="element-109">
              order@topnotchbakery.se
            </a>
          </div>
        </div>
      </div>

      <div className="text-center mb-16 px-4" data-id="element-110">
        <h2 className="text-4xl md:text-5xl font-serif text-[#1A1A1A] mb-4" data-id="element-111">
          Vårt Stående Utbud
        </h2>
        <p className="text-[#1A1A1A]/70 max-w-xl mx-auto mb-3 text-base" data-id="element-112">
          Välj produkter nedan och fyll i era uppgifter för att skicka en
          offertförfrågan. Klicka på produkterna för innehållsförteckning. Tänk
          på att vissa produkter kan variera!
        </p>
        <p className="text-[#1A1A1A]/50 max-w-xl mx-auto mb-8 text-sm italic" data-id="element-113">
          Utöver detta finns fler alternativ i vår 8 meter långa disk på plats —
          i mån av tillgänglighet.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-114">
          <div className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-[#7C8062]/10 rounded-full border border-[#7C8062]/20" data-id="element-115">
            <Clock className="w-4 h-4 text-[#7C8062]" data-id="element-116" />
            <span className="text-sm font-medium text-[#1A1A1A]/80" data-id="element-117">
              Vi svarar på alla förfrågningar inom 24 timmar
            </span>
          </div>
        </div>
      </div>

      <div className="space-y-16 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-118">
        {catalogData.map(section => {
        const isExpanded = expandedCategories[section.category] || false;
        const INITIAL_COUNT = initialCount;
        const hasMore = section.items.length > INITIAL_COUNT;
        const visibleItems = isExpanded ? section.items : section.items.slice(0, INITIAL_COUNT);
        const hiddenCount = section.items.length - INITIAL_COUNT;
        return <div key={section.category} data-id="element-119">
              <h3 className="text-2xl md:text-3xl font-serif text-[#1A1A1A] mb-8 flex items-center gap-4" data-id="element-120">
                {section.category}
                <div className="h-px bg-[#7C8062]/20 flex-1 mt-2" data-id="element-121" />
              </h3>

              <motion.div key={`${section.category}-${isExpanded ? 'expanded' : 'collapsed'}`} variants={containerVariants} initial="hidden" animate="show" className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 gap-2.5 md:gap-3" data-id="element-122">
                {(() => {
              let pkgBuilderRendered = false;
              return visibleItems.length > 0 ? visibleItems.map((item, idx) => {
                const sizeOptions = (item as any).sizeOptions;
                const hasSizeOptions = !!sizeOptions;
                const currentSize = selectedSizes[item.name] || (hasSizeOptions ? sizeOptions[0].key : '');
                const compositeKey = hasSizeOptions ? `${item.name}::${currentSize}` : item.name;
                const quantity = quantities[compositeKey] || 0;
                const totalItemQty = hasSizeOptions ? sizeOptions.reduce((sum: number, opt: any) => sum + (quantities[`${item.name}::${opt.key}`] || 0), 0) : quantity;
                const isFrukostpaket = item.name.startsWith('Frukostpaket');
                if (isFrukostpaket && showPkgBuilder) {
                  if (pkgBuilderRendered) return null;
                  pkgBuilderRendered = true;
                  return <motion.div key={`pkg-builder-${idx}`} variants={itemVariants} className="col-span-3 md:col-span-5 lg:col-span-6 p-4 md:p-5 bg-[#F2EDE4] rounded-2xl border border-[#7C8062]/20 shadow-sm" data-id="element-123">
                            <div className="max-w-3xl" data-id="element-124">
                              <div className="flex items-center justify-between mb-1" data-id="element-125">
                                <h4 className="text-lg md:text-xl font-serif text-[#1A1A1A]" data-id="element-126">
                                  Bygg ditt eget frukostpaket
                                </h4>
                                <button onClick={() => setShowPkgBuilder(false)} className="p-1.5 rounded-full hover:bg-white/60 text-[#1A1A1A]/40 hover:text-[#1A1A1A] transition-colors" data-id="element-127">
                                  <X className="w-4 h-4" data-id="element-128" />
                                </button>
                              </div>
                              <p className="text-[#1A1A1A]/70 text-xs mb-5" data-id="element-129">
                                Välj din favoritmacka och lägg till valfri dryck
                                för ett komplett paket.
                              </p>
                              <div className="space-y-4" data-id="element-130">
                                <div data-id="element-131">
                                  <p className="text-xs font-medium text-[#1A1A1A] mb-2 flex items-center gap-1.5" data-id="element-132">
                                    <span className="w-5 h-5 rounded-full bg-[#7C8062] text-white flex items-center justify-center text-[10px]" data-id="element-133">
                                      1
                                    </span>
                                    Välj macka{' '}
                                    <span className="text-[#C4993D]" data-id="element-134">*</span>
                                    <span className="text-[#1A1A1A]/40 font-normal" data-id="element-135">
                                      (välj en eller flera)
                                    </span>
                                  </p>
                                  <div className="flex flex-wrap gap-2" data-id="element-136">
                                    {['Ost & skinka', 'Salami & brie', 'Ost & grönt'].map(opt => <button key={opt} onClick={() => togglePkgOption(setPkgSandwich, opt)} className={`px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all border ${pkgSandwich.includes(opt) ? 'bg-[#7C8062] text-white border-[#7C8062] shadow-md scale-105' : 'bg-white text-[#1A1A1A] border-[#7C8062]/20 hover:border-[#7C8062]/50 hover:bg-white/80'}`} data-id="element-137">
                                        {opt}
                                      </button>)}
                                  </div>
                                </div>
                                <div data-id="element-138">
                                  <p className="text-xs font-medium text-[#1A1A1A] mb-2 flex items-center gap-1.5" data-id="element-139">
                                    <span className="w-5 h-5 rounded-full bg-[#7C8062]/20 text-[#7C8062] flex items-center justify-center text-[10px]" data-id="element-140">
                                      2
                                    </span>
                                    Lägg till smoothie{' '}
                                    <span className="text-[#1A1A1A]/40 font-normal" data-id="element-141">
                                      (Frivilligt)
                                    </span>
                                  </p>
                                  <div className="flex flex-wrap gap-2" data-id="element-142">
                                    {['Bärsmoothie', 'Tropisk smoothie'].map(opt => <button key={opt} onClick={() => togglePkgOption(setPkgSmoothie, opt)} className={`px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all border ${pkgSmoothie.includes(opt) ? 'bg-[#7C8062] text-white border-[#7C8062] shadow-md scale-105' : 'bg-white text-[#1A1A1A] border-[#7C8062]/20 hover:border-[#7C8062]/50 hover:bg-white/80'}`} data-id="element-143">
                                          {opt}
                                        </button>)}
                                  </div>
                                </div>
                                <div data-id="element-144">
                                  <p className="text-xs font-medium text-[#1A1A1A] mb-2 flex items-center gap-1.5" data-id="element-145">
                                    <span className="w-5 h-5 rounded-full bg-[#7C8062]/20 text-[#7C8062] flex items-center justify-center text-[10px]" data-id="element-146">
                                      3
                                    </span>
                                    Lägg till juice{' '}
                                    <span className="text-[#1A1A1A]/40 font-normal" data-id="element-147">
                                      (Frivilligt)
                                    </span>
                                  </p>
                                  <div className="flex flex-wrap gap-2" data-id="element-148">
                                    {['Apelsinjuice', 'Äppeljuice'].map(opt => <button key={opt} onClick={() => togglePkgOption(setPkgJuice, opt)} className={`px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all border ${pkgJuice.includes(opt) ? 'bg-[#7C8062] text-white border-[#7C8062] shadow-md scale-105' : 'bg-white text-[#1A1A1A] border-[#7C8062]/20 hover:border-[#7C8062]/50 hover:bg-white/80'}`} data-id="element-149">
                                          {opt}
                                        </button>)}
                                  </div>
                                </div>
                                <div data-id="element-150">
                                  <p className="text-xs font-medium text-[#1A1A1A] mb-2 flex items-center gap-1.5" data-id="element-151">
                                    <span className="w-5 h-5 rounded-full bg-[#7C8062]/20 text-[#7C8062] flex items-center justify-center text-[10px]" data-id="element-152">
                                      4
                                    </span>
                                    Lägg till yoghurt eller overnight oats{' '}
                                    <span className="text-[#1A1A1A]/40 font-normal" data-id="element-153">
                                      (Frivilligt)
                                    </span>
                                  </p>
                                  <div className="flex flex-wrap gap-2" data-id="element-154">
                                    {['Yoghurt med granola', 'Overnight oats med chia, mango & rostad kokos'].map(opt => <button key={opt} onClick={() => togglePkgOption(setPkgExtra, opt)} className={`px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all border ${pkgExtra.includes(opt) ? 'bg-[#7C8062] text-white border-[#7C8062] shadow-md scale-105' : 'bg-white text-[#1A1A1A] border-[#7C8062]/20 hover:border-[#7C8062]/50 hover:bg-white/80'}`} data-id="element-155">
                                        {opt}
                                      </button>)}
                                  </div>
                                </div>
                                <div data-id="element-156">
                                  <p className="text-xs font-medium text-[#1A1A1A] mb-2 flex items-center gap-1.5" data-id="element-157">
                                    <span className="w-5 h-5 rounded-full bg-[#7C8062]/20 text-[#7C8062] flex items-center justify-center text-[10px]" data-id="element-158">
                                      5
                                    </span>
                                    Lägg till bulle{' '}
                                    <span className="text-[#1A1A1A]/40 font-normal" data-id="element-159">
                                      (Frivilligt)
                                    </span>
                                  </p>
                                  <div className="flex flex-wrap gap-2" data-id="element-160">
                                    {['Kanelbulle', 'Kardemummabulle', 'Vaniljbulle'].map(opt => <button key={opt} onClick={() => togglePkgOption(setPkgBun, opt)} className={`px-3.5 py-1.5 rounded-lg text-xs font-medium transition-all border ${pkgBun.includes(opt) ? 'bg-[#7C8062] text-white border-[#7C8062] shadow-md scale-105' : 'bg-white text-[#1A1A1A] border-[#7C8062]/20 hover:border-[#7C8062]/50 hover:bg-white/80'}`} data-id="element-161">
                                        {opt}
                                      </button>)}
                                  </div>
                                </div>
                              </div>
                              {pkgSandwich.length > 0 && <div className="mt-4 p-3 bg-white/60 rounded-xl border border-[#7C8062]/10" data-id="element-162">
                                  <p className="text-xs font-medium text-[#1A1A1A] mb-1.5" data-id="element-163">
                                    Ditt valda paket:
                                  </p>
                                  <p className="text-sm text-[#7C8062] font-medium flex items-center gap-1.5 flex-wrap" data-id="element-164">
                                    {[...pkgSandwich, ...pkgSmoothie, ...pkgJuice, ...pkgExtra, ...pkgBun].map((part, i) => <Fragment key={`${part}-${i}`} data-id="element-165">
                                        {i > 0 && <Plus className="w-2.5 h-2.5 text-[#1A1A1A]/30" data-id="element-166" />}
                                        <span className="bg-white px-2.5 py-0.5 rounded-md border border-[#7C8062]/10 shadow-sm text-xs" data-id="element-167">
                                          {part}
                                        </span>
                                      </Fragment>)}
                                  </p>
                                </div>}
                              <div className="mt-5 pt-4 border-t border-[#7C8062]/10 flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-168">
                                <div className="flex items-center gap-2 bg-white rounded-lg p-1 border border-[#7C8062]/20" data-id="element-169">
                                  <button onClick={() => setPkgQuantity(Math.max(1, pkgQuantity - 1))} className="w-8 h-8 rounded-md flex items-center justify-center hover:bg-gray-50 text-[#1A1A1A] transition-colors" data-id="element-170">
                                    <Minus className="w-3.5 h-3.5" data-id="element-171" />
                                  </button>
                                  <span className="w-6 text-center font-medium text-[#1A1A1A] text-sm" data-id="element-172">
                                    {pkgQuantity}
                                  </span>
                                  <button onClick={() => setPkgQuantity(pkgQuantity + 1)} className="w-8 h-8 rounded-md flex items-center justify-center hover:bg-gray-50 text-[#1A1A1A] transition-colors" data-id="element-173">
                                    <Plus className="w-3.5 h-3.5" data-id="element-174" />
                                  </button>
                                </div>
                                <button onClick={handleAddPackageToCart} disabled={!pkgSandwich} className={`w-full sm:w-auto px-6 py-2.5 rounded-lg font-medium text-sm transition-all shadow-sm flex items-center justify-center gap-2 ${!pkgSandwich ? 'bg-white text-gray-400 border border-gray-200 cursor-not-allowed' : 'bg-[#C4993D] text-[#F2EDE4] hover:bg-[#A8832F] hover:shadow-md'}`} data-id="element-175">
                                  <ShoppingBag className="w-4 h-4" data-id="element-176" />
                                  Lägg till i beställning
                                </button>
                              </div>
                            </div>
                          </motion.div>;
                }
                return <motion.div key={idx} variants={itemVariants} className={`${`group flex flex-col gap-2 p-2 rounded-xl transition-all duration-300 ${totalItemQty > 0 ? 'bg-[#F2EDE4] border-[#7C8062]/30 shadow-sm' : 'bg-white border-transparent hover:border-[#7C8062]/20'} border`} items-start justify-start`} data-id="element-177">
                          <div className="aspect-[4/5] rounded-lg overflow-hidden bg-white border border-[#7C8062]/10 relative shadow-sm cursor-pointer w-full" onClick={() => {
                    if (item.name.startsWith('Frukostpaket')) {
                      setShowPkgBuilder(true);
                    } else {
                      setSelectedProduct(item);
                    }
                  }} data-id="element-178">
                            <img src={item.image} alt={item.name} className="w-full h-full object-contain transition-transform duration-700 group-hover:scale-105" data-id="element-179" />
                            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300 flex items-center justify-center pointer-events-none" data-id="element-180">
                              <div className="opacity-0 group-hover:opacity-100 bg-white/90 text-[#1A1A1A] text-xs font-medium px-3 py-1.5 rounded-full flex items-center gap-1.5 transition-opacity duration-300 transform translate-y-2 group-hover:translate-y-0" data-id="element-181">
                                <Info className="w-3.5 h-3.5" data-id="element-182" /> Info
                              </div>
                            </div>
                          </div>

                          <div className="flex flex-col flex-1 justify-between gap-2 w-full" data-id="element-183">
                            <div className="text-center" data-id="element-184">
                              <p className="text-xs md:text-sm font-medium text-[#1A1A1A] leading-snug whitespace-pre-line" data-id="element-185">
                                {item.name}
                              </p>
                              {hasSizeOptions && totalItemQty > 0 && <p className="text-xs text-[#7C8062] mt-1 font-medium" data-id="element-186">
                                  {sizeOptions.map((opt: any) => {
                          const q = quantities[`${item.name}::${opt.key}`] || 0;
                          return q > 0 ? `${q} ${opt.label.toLowerCase()}` : null;
                        }).filter(Boolean).join(', ')}
                                </p>}
                            </div>

                            {hasSizeOptions && <div className="flex items-center justify-center bg-white rounded-md p-0.5 border border-gray-200 mx-auto w-full max-w-[120px]" data-id="element-187">
                                {sizeOptions.map((opt: any) => <button key={opt.key} onClick={() => setSelectedSizes(prev => ({
                        ...prev,
                        [item.name]: opt.key
                      }))} className={`flex-1 text-xs py-1 rounded-md transition-colors ${currentSize === opt.key ? 'bg-[#F2EDE4] text-[#1A1A1A] font-medium shadow-sm' : 'text-gray-500 hover:text-[#1A1A1A]'}`} data-id="element-188">
                                    {opt.label}
                                  </button>)}
                              </div>}

                            {item.name.startsWith('Frukostpaket') ? <button onClick={() => setShowPkgBuilder(true)} className="w-full py-1.5 px-2 rounded-md text-[10px] md:text-xs font-medium bg-[#C4993D] text-[#F2EDE4] hover:bg-[#A8832F] transition-colors shadow-sm flex items-center justify-center gap-1" data-id="element-189">
                                <ShoppingBag className="w-3 h-3" data-id="element-190" />
                                Skapa paket
                              </button> : <div className="flex items-center justify-center gap-2 bg-gray-50/50 rounded-md p-1 border border-gray-100" data-id="element-191">
                                <button onClick={() => handleQuantityChange(compositeKey, -1)} disabled={quantity === 0} className={`w-6 h-6 rounded flex items-center justify-center transition-colors ${quantity > 0 ? 'bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-50 border border-gray-200' : 'text-gray-300 cursor-not-allowed'}`} data-id="element-192">
                                  <Minus className="w-3 h-3" data-id="element-193" />
                                </button>
                                <span className="w-4 text-center text-xs font-medium text-[#1A1A1A]" data-id="element-194">
                                  {quantity}
                                </span>
                                <button onClick={() => handleQuantityChange(compositeKey, 1)} className="w-6 h-6 rounded bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-50 border border-gray-200 flex items-center justify-center transition-colors" data-id="element-195">
                                  <Plus className="w-3 h-3" data-id="element-196" />
                                </button>
                              </div>}
                          </div>
                        </motion.div>;
              }) : <motion.div variants={itemVariants} className="flex flex-col gap-4" data-id="element-197">
                      <div className="aspect-square md:aspect-[4/5] rounded-2xl border-2 border-dashed border-[#7C8062]/20 bg-[#F2EDE4]/50 flex flex-col items-center justify-center gap-3 p-4 text-center" data-id="element-198">
                        <span className="text-4xl md:text-5xl" data-id="element-199">🥖</span>
                        <p className="text-sm md:text-base font-medium text-[#1A1A1A]/50" data-id="element-200">
                          Kommer snart
                        </p>
                      </div>
                    </motion.div>;
            })()}
              </motion.div>

              {hasMore && <div className="flex justify-center mt-6" data-id="element-201">
                  <button onClick={() => setExpandedCategories(prev => ({
              ...prev,
              [section.category]: !isExpanded
            }))} className="flex items-center gap-2 px-6 py-2.5 text-sm font-medium text-[#7C8062] bg-white hover:bg-[#7C8062]/5 border border-[#7C8062]/20 rounded-full transition-colors shadow-sm" data-id="element-202">
                    {isExpanded ? 'Visa färre' : `Visa fler +${hiddenCount} produkter`}
                  </button>
                </div>}
            </div>;
      })}
      </div>

      {/* OBS Reminder - above bottom bar */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12 mb-28" data-id="element-203">
        <div className="flex items-start gap-3 p-4 bg-[#F2EDE4] rounded-xl border border-[#7C8062]/20" data-id="element-204">
          <Info className="w-5 h-5 text-[#7C8062] shrink-0 mt-0.5" data-id="element-205" />
          <div className="text-sm text-[#1A1A1A]/70" data-id="element-206">
            <p data-id="element-207">
              <span className="font-semibold text-[#1A1A1A]/90" data-id="element-208">OBS:</span> Alla
              beställningar är förfrågningar. Var ute minst 3 dagar i förväg så
              att vi hinner hantera er volym.
            </p>
            <p className="mt-2" data-id="element-209">
              Har du frågor? Kontakta oss på{' '}
              <a href="mailto:order@topnotchbakery.se" className="text-[#7C8062] font-medium underline underline-offset-2 hover:text-[#6A6D53] transition-colors" data-id="element-210">
                order@topnotchbakery.se
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Order Summary Bottom Bar — only visible when items are selected */}
      <AnimatePresence data-id="element-211">
        {totalItems > 0 && <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0,
        transition: {
          type: 'spring',
          damping: 25,
          stiffness: 200
        }
      }} exit={{
        y: '100%',
        transition: {
          duration: 0.25,
          ease: 'easeInOut'
        }
      }} className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#7C8062]/15 shadow-[0_-10px_40px_rgba(0,0,0,0.03)] z-30" data-id="element-212">
            <div className="max-w-7xl mx-auto px-4 py-4 md:py-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-213">
              <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-8 w-full md:w-auto" data-id="element-214">
                <button onClick={() => setIsCartOpen(true)} className="flex items-center gap-3 bg-[#F2EDE4] px-4 py-2 rounded-xl border border-[#7C8062]/20 hover:bg-[#7C8062]/10 transition-colors cursor-pointer" data-id="element-215">
                  <ShoppingBag className="w-6 h-6 text-[#7C8062]" data-id="element-216" />
                  <div className="text-left" data-id="element-217">
                    <p className="text-xs text-[#1A1A1A]/60 font-medium" data-id="element-218">
                      Visa kundvagn
                    </p>
                    <p className="text-lg font-serif text-[#1A1A1A]" data-id="element-219">
                      {totalItems} st valda
                    </p>
                  </div>
                </button>

                <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto hidden lg:flex" data-id="element-220">
                  <div className="relative flex-1 sm:flex-none" data-id="element-221">
                    <input type="date" value={orderDate} onChange={e => setOrderDate(e.target.value)} className="w-full h-11 pl-10 pr-4 rounded-lg border border-[#7C8062]/20 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/20 outline-none transition-all text-sm" data-id="element-222" />
                    <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-223" />
                  </div>
                  <div className="relative flex-1 sm:flex-none" data-id="element-224">
                    <input type="time" value={orderTime} onChange={e => setOrderTime(e.target.value)} className="w-full h-11 pl-10 pr-4 rounded-lg border border-[#7C8062]/20 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/20 outline-none transition-all text-sm" data-id="element-225" />
                    <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-226" />
                  </div>
                </div>

                <div className="flex items-center bg-gray-50 p-1 rounded-lg w-full sm:w-auto hidden lg:flex border border-gray-100" data-id="element-227">
                  <button onClick={() => setDeliveryType('avhämtning')} className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${deliveryType === 'avhämtning' ? 'bg-white text-[#1A1A1A] shadow-sm' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-228">
                    <MapPin className="w-4 h-4" data-id="element-229" />
                    Avhämtning
                  </button>
                  <button onClick={() => setDeliveryType('upphämtning')} className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${deliveryType === 'upphämtning' ? 'bg-white text-[#1A1A1A] shadow-sm' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-230">
                    <Truck className="w-4 h-4" data-id="element-231" />
                    Utkörning
                  </button>
                </div>
              </div>

              <Button onClick={() => setIsCartOpen(true)} disabled={totalItems === 0} className="w-full md:w-auto min-w-[220px] py-3.5 text-base shadow-sm" data-id="element-232">
                Granska förfrågan
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Slide-in Cart Sidebar */}
      <AnimatePresence data-id="element-233">
        {isCartOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1,
          transition: {
            duration: 0.2
          }
        }} exit={{
          opacity: 0,
          transition: {
            duration: 0.2
          }
        }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={() => setIsCartOpen(false)} data-id="element-234" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0,
          transition: {
            type: 'spring',
            damping: 25,
            stiffness: 200
          }
        }} exit={{
          x: '100%',
          transition: {
            duration: 0.25,
            ease: 'easeInOut'
          }
        }} className="fixed top-0 right-0 bottom-0 w-full max-w-md bg-white shadow-2xl z-50 flex flex-col" data-id="element-235">
              <div className="p-6 border-b border-[#7C8062]/15 flex items-center justify-between bg-[#F2EDE4]/50" data-id="element-236">
                <div className="flex items-center gap-3" data-id="element-237">
                  <ShoppingBag className="w-6 h-6 text-[#7C8062]" data-id="element-238" />
                  <h2 className="text-2xl font-serif text-[#1A1A1A]" data-id="element-239">
                    Offert Kundvagn
                  </h2>
                </div>
                <button onClick={() => setIsCartOpen(false)} className="p-2 text-gray-400 hover:text-[#1A1A1A] hover:bg-white rounded-full transition-colors" data-id="element-240">
                  <X className="w-6 h-6" data-id="element-241" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-6 space-y-4" data-id="element-242">
                {totalItems === 0 ? <div className="h-full flex flex-col items-center justify-center text-center space-y-4 text-[#1A1A1A]/50" data-id="element-243">
                    <ShoppingBag className="w-16 h-16 text-[#7C8062]/30" data-id="element-244" />
                    <p data-id="element-245">
                      Din kundvagn är tom.
                      <br data-id="element-246" />
                      Lägg till produkter från utbudet.
                    </p>
                  </div> : <>
                    {/* Summary badge */}
                    <div className="flex items-center justify-between pb-3 border-b border-[#7C8062]/15" data-id="element-247">
                      <div className="flex items-center gap-2" data-id="element-248">
                        <div className="w-7 h-7 rounded-full bg-[#7C8062] text-white text-xs font-bold flex items-center justify-center" data-id="element-249">
                          {totalItems}
                        </div>
                        <span className="text-sm font-medium text-[#1A1A1A]" data-id="element-250">
                          {totalItems === 1 ? '1 produkt vald' : `${totalItems} produkter valda`}
                        </span>
                      </div>
                      <button onClick={() => setQuantities({})} className="text-xs text-red-500 hover:text-red-600 font-medium flex items-center gap-1 px-2 py-1 rounded-md hover:bg-red-50 transition-colors" data-id="element-251">
                        <Trash2 className="w-3 h-3" data-id="element-252" />
                        Rensa alla
                      </button>
                    </div>

                    {/* Products grouped by category */}
                    {(() => {
                const items = getSelectedItemsDetails();
                const grouped = items.reduce<Record<string, typeof items>>((acc, item) => {
                  if (!acc[item.category]) acc[item.category] = [];
                  acc[item.category].push(item);
                  return acc;
                }, {});
                return Object.entries(grouped).map(([category, categoryItems]) => <div key={category} className="space-y-2" data-id="element-253">
                            <div className="flex items-center gap-2 pt-1" data-id="element-254">
                              <span className="text-xs font-semibold uppercase tracking-wider text-[#7C8062]" data-id="element-255">
                                {category}
                              </span>
                              <div className="h-px bg-[#7C8062]/15 flex-1" data-id="element-256" />
                              <span className="text-xs text-[#1A1A1A]/40 font-medium" data-id="element-257">
                                {categoryItems.reduce((sum, i) => sum + i.quantity, 0)}{' '}
                                st
                              </span>
                            </div>
                            {categoryItems.map(item => <motion.div layout initial={{
                    opacity: 0,
                    y: 10
                  }} animate={{
                    opacity: 1,
                    y: 0
                  }} key={item.compositeKey} className="flex items-center gap-3 p-2.5 bg-white border border-[#7C8062]/10 rounded-xl" data-id="element-258">
                                <img src={item.image} alt={item.name} className="w-14 h-14 rounded-lg object-cover border border-[#7C8062]/10 shrink-0" data-id="element-259" />
                                <div className="flex-1 min-w-0" data-id="element-260">
                                  <p className="text-sm font-medium text-[#1A1A1A] leading-snug line-clamp-2" data-id="element-261">
                                    {item.name}
                                  </p>
                                  <div className="flex items-center gap-2 mt-1.5" data-id="element-262">
                                    <div className="flex items-center gap-1.5 bg-[#F2EDE4]/60 rounded-md px-1 py-0.5 border border-[#7C8062]/10" data-id="element-263">
                                      <button onClick={() => handleQuantityChange(item.compositeKey, -1)} className="w-6 h-6 rounded flex items-center justify-center bg-white text-[#1A1A1A] hover:bg-gray-50 border border-gray-200 transition-colors" data-id="element-264">
                                        <Minus className="w-3 h-3" data-id="element-265" />
                                      </button>
                                      <span className="w-5 text-center text-sm font-semibold text-[#1A1A1A]" data-id="element-266">
                                        {item.quantity}
                                      </span>
                                      <button onClick={() => handleQuantityChange(item.compositeKey, 1)} className="w-6 h-6 rounded bg-white text-[#1A1A1A] hover:bg-gray-50 border border-gray-200 flex items-center justify-center transition-colors" data-id="element-267">
                                        <Plus className="w-3 h-3" data-id="element-268" />
                                      </button>
                                    </div>
                                    <button onClick={() => handleQuantityChange(item.compositeKey, -item.quantity)} className="ml-auto p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors" title="Ta bort" data-id="element-269">
                                      <Trash2 className="w-3.5 h-3.5" data-id="element-270" />
                                    </button>
                                  </div>
                                </div>
                              </motion.div>)}
                          </div>);
              })()}

                    {/* Divider between products and form */}
                    <div className="relative py-4" data-id="element-271">
                      <div className="absolute inset-x-0 top-1/2 h-px bg-[#7C8062]/20" data-id="element-272" />
                      <div className="relative flex justify-center" data-id="element-273">
                        <span className="bg-white px-4 text-xs font-semibold uppercase tracking-wider text-[#7C8062]" data-id="element-274">
                          Uppgifter & Leverans
                        </span>
                      </div>
                    </div>

                    {/* Form section - now inside the same scroll container */}
                    <div className="space-y-4 p-4 bg-[#F2EDE4]/30 rounded-xl border border-[#7C8062]/10" data-id="element-275">
                      {/* Företag / Privatperson */}
                      <div className="space-y-1.5" data-id="element-276">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-277">
                          Kundtyp
                        </label>
                        <div className="flex items-center bg-white p-1 rounded-lg border border-[#7C8062]/15" data-id="element-278">
                          <button onClick={() => setCustomerType('företag')} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${customerType === 'företag' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-279">
                            🏢 Företag
                          </button>
                          <button onClick={() => {
                      setCustomerType('privatperson');
                      setDeliveryType('avhämtning');
                    }} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${customerType === 'privatperson' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-280">
                            👤 Privatperson
                          </button>
                        </div>
                        {customerType === 'privatperson' && <div className="flex items-start gap-2 p-2.5 bg-[#F2EDE4]/20 rounded-lg border border-[#7C8062]/10 text-xs text-[#1A1A1A]/70" data-id="element-281">
                            <span className="text-base leading-none mt-px" data-id="element-282">
                              💳
                            </span>
                            <span data-id="element-283">
                              Privatpersoner betalar på plats vid avhämtning.
                              Utkörning är inte tillgängligt för privatpersoner.
                            </span>
                          </div>}
                      </div>

                      {/* Kontaktuppgifter */}
                      <div className="space-y-3 p-3 bg-white rounded-xl border border-[#7C8062]/15" data-id="element-284">
                        <p className="text-xs font-medium text-[#7C8062]" data-id="element-285">
                          {customerType === 'företag' ? '🏢 Företagsuppgifter' : '👤 Dina uppgifter'}
                        </p>
                        {customerType === 'företag' && <>
                            <div data-id="element-286">
                              <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-287">
                                Företagsnamn *
                              </label>
                              <input type="text" value={companyName} onChange={e => {
                        setCompanyName(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.companyName;
                          return n;
                        });
                      }} placeholder="Företagets namn" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.companyName ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-288" />
                              {fieldErrors.companyName && <p className="text-xs text-red-500 mt-1" data-id="element-289">
                                  {fieldErrors.companyName}
                                </p>}
                            </div>
                            <div data-id="element-290">
                              <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-291">
                                Organisationsnummer *
                              </label>
                              <input type="text" value={orgNumber} onChange={e => {
                        setOrgNumber(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.orgNumber;
                          return n;
                        });
                      }} placeholder="XXXXXX-XXXX" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.orgNumber ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-292" />
                              {fieldErrors.orgNumber && <p className="text-xs text-red-500 mt-1" data-id="element-293">
                                  {fieldErrors.orgNumber}
                                </p>}
                            </div>
                            <div data-id="element-294">
                              <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-295">
                                Fakturamejl *
                              </label>
                              <input type="email" value={invoiceEmail} onChange={e => {
                        setInvoiceEmail(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.invoiceEmail;
                          return n;
                        });
                      }} placeholder="faktura@foretag.se" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.invoiceEmail ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-296" />
                              {fieldErrors.invoiceEmail && <p className="text-xs text-red-500 mt-1" data-id="element-297">
                                  {fieldErrors.invoiceEmail}
                                </p>}
                            </div>
                            <div data-id="element-298">
                              <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-299">
                                Referens / Kostnadsställe *
                              </label>
                              <input type="text" value={invoiceReference} onChange={e => {
                        setInvoiceReference(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.invoiceReference;
                          return n;
                        });
                      }} placeholder="Er referens eller kostnadsställe" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.invoiceReference ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-300" />
                              {fieldErrors.invoiceReference && <p className="text-xs text-red-500 mt-1" data-id="element-301">
                                  {fieldErrors.invoiceReference}
                                </p>}
                            </div>
                            <div data-id="element-302">
                              <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-303">
                                Önskemål / Övriga önskemål
                              </label>
                              <textarea value={önskemål} onChange={e => setÖnskemål(e.target.value)} placeholder="Eventuella allergier, specialkost eller andra önskemål..." className="w-full min-h-[80px] p-3 rounded-lg border border-[#7C8062]/15 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/15 outline-none transition-all text-sm resize-y" data-id="element-304" />
                            </div>
                          </>}
                        <div data-id="element-305">
                          <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-306">
                            {customerType === 'företag' ? 'Kontaktperson *' : 'Namn *'}
                          </label>
                          <input type="text" value={contactPerson} onChange={e => {
                      setContactPerson(e.target.value);
                      setFieldErrors(prev => {
                        const n = {
                          ...prev
                        };
                        delete n.contactPerson;
                        return n;
                      });
                    }} placeholder={customerType === 'företag' ? 'Kontaktpersonens namn' : 'Ditt för- och efternamn'} className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.contactPerson ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-307" />
                          {fieldErrors.contactPerson && <p className="text-xs text-red-500 mt-1" data-id="element-308">
                              {fieldErrors.contactPerson}
                            </p>}
                        </div>
                        <div className="grid grid-cols-2 gap-2" data-id="element-309">
                          <div data-id="element-310">
                            <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-311">
                              E-post *
                            </label>
                            <input type="email" value={customerEmail} onChange={e => {
                        setCustomerEmail(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.customerEmail;
                          return n;
                        });
                      }} placeholder="din@epost.se" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.customerEmail ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-312" />
                            {fieldErrors.customerEmail && <p className="text-xs text-red-500 mt-1" data-id="element-313">
                                {fieldErrors.customerEmail}
                              </p>}
                          </div>
                          <div data-id="element-314">
                            <label className="block text-xs font-medium text-[#7C8062] mb-1" data-id="element-315">
                              Telefon *
                            </label>
                            <input type="tel" value={customerPhone} onChange={e => {
                        setCustomerPhone(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.customerPhone;
                          return n;
                        });
                      }} placeholder="070-123 45 67" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.customerPhone ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062] focus:border-[#7C8062] focus:ring-[#7C8062]'}`} data-id="element-316" />
                            {fieldErrors.customerPhone && <p className="text-xs text-red-500 mt-1" data-id="element-317">
                                {fieldErrors.customerPhone}
                              </p>}
                          </div>
                        </div>
                      </div>

                      {/* Engång / Återkommande */}
                      <div className="space-y-1.5" data-id="element-318">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-319">
                          Ordertyp
                        </label>
                        <div className="flex items-center bg-white p-1 rounded-lg border border-[#7C8062]/15" data-id="element-320">
                          <button onClick={() => setOrderFrequency('engång')} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${orderFrequency === 'engång' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-321">
                            Engångsbeställning
                          </button>
                          <button onClick={() => setOrderFrequency('återkommande')} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${orderFrequency === 'återkommande' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-322">
                            Återkommande
                          </button>
                        </div>
                        {orderFrequency === 'återkommande' && <div className="space-y-3 p-3 bg-white rounded-xl border border-[#7C8062]/15 mt-2" data-id="element-323">
                            <p className="text-xs font-medium text-[#7C8062] flex items-center gap-1.5" data-id="element-324">
                              🔄 Hur ofta vill ni ha leverans?
                            </p>

                            <div className="flex gap-2" data-id="element-325">
                              {(['veckovis', 'månadsvis', 'annat'] as const).map(type => <button key={type} onClick={() => setRecurringType(type)} className={`flex-1 px-3 py-2 rounded-lg text-xs font-medium transition-all ${recurringType === type ? 'bg-[#F2EDE4] text-[#1A1A1A] border border-[#7C8062]/15 shadow-sm' : 'bg-gray-50 text-[#1A1A1A]/60 border border-transparent hover:bg-gray-100'}`} data-id="element-326">
                                  {type === 'veckovis' ? '📅 Veckovis' : type === 'månadsvis' ? '🗓️ Månadsvis' : '✏️ Annat'}
                                </button>)}
                            </div>

                            {recurringType === 'veckovis' && <div className="space-y-2" data-id="element-327">
                                <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-328">
                                  Vilka veckodagar?
                                </label>
                                <div className="grid grid-cols-3 gap-1.5" data-id="element-329">
                                  {['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'].map(day => <button key={day} onClick={() => toggleWeekday(day)} className={`px-2 py-2 rounded-lg text-xs font-medium transition-all ${selectedWeekdays.includes(day) ? 'bg-[#7C8062] text-white shadow-sm' : 'bg-gray-50 text-[#1A1A1A]/70 border border-gray-200 hover:bg-gray-100'}`} data-id="element-330">
                                      {day.slice(0, 3)}
                                    </button>)}
                                </div>
                                {selectedWeekdays.length > 0 && <p className="text-xs text-[#1A1A1A]/50 italic" data-id="element-331">
                                    Valda: {selectedWeekdays.join(', ')}
                                  </p>}
                              </div>}

                            {recurringType === 'månadsvis' && <div className="space-y-2" data-id="element-332">
                                <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-333">
                                  Vilka datum i månaden?
                                </label>
                                <div className="grid grid-cols-7 gap-1" data-id="element-334">
                                  {Array.from({
                          length: 31
                        }, (_, i) => i + 1).map(date => <button key={date} onClick={() => toggleMonthDate(date)} className={`w-full aspect-square rounded-md text-xs font-medium transition-all flex items-center justify-center ${selectedMonthDates.includes(date) ? 'bg-[#7C8062] text-white shadow-sm' : 'bg-gray-50 text-[#1A1A1A]/70 hover:bg-gray-100'}`} data-id="element-335">
                                      {date}
                                    </button>)}
                                </div>
                                {selectedMonthDates.length > 0 && <p className="text-xs text-[#1A1A1A]/50 italic" data-id="element-336">
                                    Valda datum:{' '}
                                    {selectedMonthDates.sort((a, b) => a - b).join(', ')}
                                  </p>}
                              </div>}

                            {recurringType === 'annat' && <div className="space-y-2" data-id="element-337">
                                <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-338">
                                  Beskriv önskat upplägg
                                </label>
                                <textarea value={recurringNote} onChange={e => setRecurringNote(e.target.value)} placeholder="T.ex. varannan vecka på tisdagar, första och tredje fredagen varje månad..." className="w-full min-h-[70px] p-3 rounded-lg border border-[#7C8062]/15 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/15 outline-none transition-all text-sm resize-y" data-id="element-339" />
                              </div>}

                            <p className="text-xs text-[#1A1A1A]/50 bg-[#F2EDE4]/20 p-2 rounded-md border border-[#7C8062]/10" data-id="element-340">
                              Vi bekräftar schemat i vår offert och anpassar
                              efter era önskemål.
                            </p>
                          </div>}
                      </div>

                      {/* Datum & Tidsintervall */}
                      <div className="space-y-2" data-id="element-341">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-342">
                          {orderFrequency === 'återkommande' ? 'Önskat startdatum' : 'Datum'}
                        </label>
                        <div className="relative" data-id="element-343">
                          <input type="date" value={orderDate} onChange={e => {
                      setOrderDate(e.target.value);
                      setFieldErrors(prev => {
                        const n = {
                          ...prev
                        };
                        delete n.orderDate;
                        return n;
                      });
                    }} className={`w-full h-10 pl-10 pr-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.orderDate ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-344" />
                          <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-345" />
                        </div>
                        {fieldErrors.orderDate && <p className="text-xs text-red-500 mt-1" data-id="element-346">
                            {fieldErrors.orderDate}
                          </p>}
                      </div>

                      <div className="space-y-2" data-id="element-347">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-348">
                          Tid (från - till)
                        </label>
                        <div className="flex items-center gap-2" data-id="element-349">
                          <div className="relative flex-1" data-id="element-350">
                            <input type="time" value={orderTime} onChange={e => {
                        setOrderTime(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.orderTime;
                          return n;
                        });
                      }} className={`w-full h-10 pl-10 pr-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.orderTime ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-351" />
                            <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-352" />
                          </div>
                          <span className="text-[#1A1A1A]/40" data-id="element-353">-</span>
                          <div className="relative flex-1" data-id="element-354">
                            <input type="time" value={orderTimeTo} onChange={e => setOrderTimeTo(e.target.value)} className="w-full h-10 pl-10 pr-3 rounded-lg border border-[#7C8062]/15 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/15 outline-none transition-all text-sm" data-id="element-355" />
                            <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-356" />
                          </div>
                        </div>
                        {fieldErrors.orderTime && <p className="text-xs text-red-500 mt-1" data-id="element-357">
                            {fieldErrors.orderTime}
                          </p>}
                        <div className="flex items-center gap-2 mt-2" data-id="element-358">
                          <input type="checkbox" id="exactTime" checked={exactTime} onChange={e => setExactTime(e.target.checked)} className="rounded border-[#7C8062]/20 text-[#7C8062] focus:ring-[#7C8062]" data-id="element-359" />
                          <label htmlFor="exactTime" className="text-xs text-[#1A1A1A]/70" data-id="element-360">
                            Detta är en exakt tid (ej flexibel)
                          </label>
                        </div>
                      </div>

                      {/* Leveransadress */}
                      {customerType === 'företag' && deliveryType === 'upphämtning' && <div className="space-y-3 p-3 bg-white rounded-xl border border-[#7C8062]/15" data-id="element-361">
                            <p className="text-xs font-medium text-[#7C8062]" data-id="element-362">
                              🚚 Leveransadress
                            </p>
                            <div data-id="element-363">
                              <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-364">
                                Gatuadress *
                              </label>
                              <input type="text" value={deliveryStreet} onChange={e => {
                      setDeliveryStreet(e.target.value);
                      setFieldErrors(prev => {
                        const n = {
                          ...prev
                        };
                        delete n.deliveryStreet;
                        return n;
                      });
                    }} placeholder="Gatunamn 1" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.deliveryStreet ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-365" />
                              {fieldErrors.deliveryStreet && <p className="text-xs text-red-500 mt-1" data-id="element-366">
                                  {fieldErrors.deliveryStreet}
                                </p>}
                            </div>
                            <div className="grid grid-cols-2 gap-2" data-id="element-367">
                              <div data-id="element-368">
                                <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-369">
                                  Postnummer *
                                </label>
                                <input type="text" value={deliveryPostalCode} onChange={e => {
                        setDeliveryPostalCode(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.deliveryPostalCode;
                          return n;
                        });
                      }} placeholder="123 45" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.deliveryPostalCode ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-370" />
                                {fieldErrors.deliveryPostalCode && <p className="text-xs text-red-500 mt-1" data-id="element-371">
                                    {fieldErrors.deliveryPostalCode}
                                  </p>}
                              </div>
                              <div data-id="element-372">
                                <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-373">
                                  Ort *
                                </label>
                                <input type="text" value={deliveryCity} onChange={e => {
                        setDeliveryCity(e.target.value);
                        setFieldErrors(prev => {
                          const n = {
                            ...prev
                          };
                          delete n.deliveryCity;
                          return n;
                        });
                      }} placeholder="Stad" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.deliveryCity ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-374" />
                                {fieldErrors.deliveryCity && <p className="text-xs text-red-500 mt-1" data-id="element-375">
                                    {fieldErrors.deliveryCity}
                                  </p>}
                              </div>
                            </div>
                          </div>}
                    </div>
                  </>}
              </div>

              <div className="p-6 border-t border-[#7C8062]/15 bg-white" data-id="element-376">
                {submitError && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600" data-id="element-377">
                    {submitError}
                  </div>}
                {isSubmitted ? <div className="text-center space-y-3" data-id="element-378">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-379">
                      <span className="text-2xl" data-id="element-380">✓</span>
                    </div>
                    <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-381">
                      Förfrågan skickad!
                    </h3>
                    <p className="text-sm text-[#1A1A1A]/70" data-id="element-382">
                      Vi återkommer till er inom kort med en bekräftelse.
                    </p>
                    <Button onClick={() => {
                setIsSubmitted(false);
                setIsCartOpen(false);
                setQuantities({});
              }} className="w-full mt-4" data-id="element-383">
                      Stäng
                    </Button>
                  </div> : <Button onClick={handleContinue} isLoading={isSubmitting} className="w-full py-4 text-base shadow-sm" data-id="element-384">
                    Skicka förfrågan
                  </Button>}
              </div>
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Nutritional Info Modal */}
      <AnimatePresence data-id="element-385">
        {selectedProduct && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setSelectedProduct(null)} data-id="element-386">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col md:flex-row" data-id="element-387">
              <div className="w-full md:w-1/2 h-64 md:h-auto relative" data-id="element-388">
                <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-full object-cover" data-id="element-389" />
              </div>

              <div className="w-full md:w-1/2 p-6 md:p-8 flex flex-col" data-id="element-390">
                <div className="flex justify-between items-start mb-6" data-id="element-391">
                  <h3 className="text-2xl font-serif text-[#1A1A1A] pr-8" data-id="element-392">
                    {selectedProduct.name}
                  </h3>
                  <button onClick={() => setSelectedProduct(null)} className="p-2 -mr-2 -mt-2 text-gray-400 hover:text-[#1A1A1A] hover:bg-gray-100 rounded-full transition-colors" data-id="element-393">
                    <X className="w-5 h-5" data-id="element-394" />
                  </button>
                </div>

                <div className="flex-1 space-y-6" data-id="element-395">
                  <p className="text-sm text-[#1A1A1A]/80 leading-relaxed whitespace-pre-line" data-id="element-396">
                    {selectedProduct.description}
                  </p>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-397">
                  <div className="flex items-center gap-4 w-full sm:w-auto" data-id="element-398">
                    {selectedProduct.sizeOptions && <div className="flex items-center bg-white rounded-lg p-1 border border-gray-200 w-full sm:w-[140px]" data-id="element-399">
                        {selectedProduct.sizeOptions.map((opt: any) => <button key={opt.key} onClick={() => setSelectedSizes(prev => ({
                    ...prev,
                    [selectedProduct.name]: opt.key
                  }))} className={`flex-1 text-sm py-1.5 rounded-md transition-colors ${(selectedSizes[selectedProduct.name] || selectedProduct.sizeOptions![0].key) === opt.key ? 'bg-[#F2EDE4] text-[#1A1A1A] font-medium shadow-sm' : 'text-gray-500 hover:text-[#1A1A1A]'}`} data-id="element-400">
                            {opt.label}
                          </button>)}
                      </div>}

                    <div className="flex items-center gap-3 bg-gray-50 rounded-lg p-1.5 border border-gray-200" data-id="element-401">
                      <button onClick={() => handleQuantityChange(selectedProduct.sizeOptions ? `${selectedProduct.name}::${selectedSizes[selectedProduct.name] || selectedProduct.sizeOptions[0].key}` : selectedProduct.name, -1)} disabled={!(quantities[selectedProduct.sizeOptions ? `${selectedProduct.name}::${selectedSizes[selectedProduct.name] || selectedProduct.sizeOptions[0].key}` : selectedProduct.name] > 0)} className={`w-10 h-10 rounded-md flex items-center justify-center transition-colors ${quantities[selectedProduct.sizeOptions ? `${selectedProduct.name}::${selectedSizes[selectedProduct.name] || selectedProduct.sizeOptions[0].key}` : selectedProduct.name] > 0 ? 'bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-100 border border-gray-200' : 'text-gray-300 cursor-not-allowed'}`} data-id="element-402">
                        <Minus className="w-5 h-5" data-id="element-403" />
                      </button>
                      <span className="w-8 text-center font-medium text-[#1A1A1A] text-lg" data-id="element-404">
                        {quantities[selectedProduct.sizeOptions ? `${selectedProduct.name}::${selectedSizes[selectedProduct.name] || selectedProduct.sizeOptions[0].key}` : selectedProduct.name] || 0}
                      </span>
                      <button onClick={() => handleQuantityChange(selectedProduct.sizeOptions ? `${selectedProduct.name}::${selectedSizes[selectedProduct.name] || selectedProduct.sizeOptions[0].key}` : selectedProduct.name, 1)} className="w-10 h-10 rounded-md bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-100 border border-gray-200 flex items-center justify-center transition-colors" data-id="element-405">
                        <Plus className="w-5 h-5" data-id="element-406" />
                      </button>
                    </div>
                  </div>

                  <Button onClick={() => setSelectedProduct(null)} className="w-full sm:w-auto" data-id="element-407">
                    Klar
                  </Button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}